import { ComponentAlignment } from "@kunduz/feature-landing-pages";

export const defaultComponentAlignmentFields = {
  alignmentDesktop: {
    type: "select",
    label: "Alignment Desktop",
    options: [
      { value: "left", label: "Left" },
      { value: "center", label: "Center" },
      { value: "right", label: "Right" },
    ],
  },
  alignmentTablet: {
    type: "select",
    label: "Alignment Tablet",
    options: [
      { value: "left", label: "Left" },
      { value: "center", label: "Center" },
      { value: "right", label: "Right" },
    ],
  },
  alignmentMobile: {
    type: "select",
    label: "Alignment Mobile",
    options: [
      { value: "left", label: "Left" },
      { value: "center", label: "Center" },
      { value: "right", label: "Right" },
    ],
  },
};

export const defaultComponentAlignment: {
  alignmentMobile?: ComponentAlignment;
  alignmentTablet?: ComponentAlignment;
  alignmentDesktop?: ComponentAlignment;
} = {
  alignmentMobile: "center",
  alignmentTablet: "center",
  alignmentDesktop: "center",
};
